import React, { useState, useContext, useEffect } from "react";
import { IntlProvider } from "react-intl";
import styled, { css } from "styled-components";

import { createBrowserHistory } from "history";


import { Link } from "react-router-dom";


import {
  CssTableLine,
  CssSwitchSub,
  CssTableCountry,
  CssTableFlag,
  CssTableDays,
  CssInputDay,
  SelectSquare,
  PAinfoCollapsible
} from "../uikit2";

import {
  InputCopy,
  FormGroup,
  FormFooter,
  Button,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Pill,
  Slider,
  Radio,
  Breadcrumbs,
  Head,
  Card,
  Input,
  RadioGroup,
  Switch,
  Icon,
  ButtonAction,
  Tag,
  Notification,
  ContentBlock
} from "xsolla-uikit";
import PAh2 from "../PAh2";

import { gcCountries } from "../../data/countries";

import PAContentBlock from "../PAContentBlock";
import { PArefundsBadge } from "./PArefundsBadge";
import { PArefundLevelSelect } from "./PArefundLevelSelect";
import { PArefundHint } from "./PArefundHint";
import { PArefundPreview } from "./PArefundPreview";
import PAmodal from "../PApop";
import { xsollaProducts } from '../../data/xsollaProducts';
import { PArefundPolicySwitcher } from './PAgkRefundSimple';
import { policies } from "./policies";
import { gcRefunds } from "./gcRefunds";

export default function PAgkRefundEdit({
  history,
  name = "Login for My Game: Ultimate Edition",
  status = "draft",
  showAsPage = true,
  handleSave = ()=>void(0)
}) {
  const [level, setLevel] = useState("loyal");
  const [curPrev, setCurPrev] = useState('game_store');

  return (

    <div>
<br/>

      {/* <PArefundHint opened={false}/> */}



        <ContentBlock appearance="flatten">
          <FormGroup >
            <PAContentBlock
              // title="Edit refund policy"
              // title="Policy highlights"
              border={false}
              // sticky="Strict policy"
            >


              <FormGroup
                indentation="md"
                label="Set up a refund policy for the virtual items"
              >
                <PArefundLevelSelect level={level} handleChange={setLevel} />
              </FormGroup>

              <PArefundPolicySwitcher
                  curPrev={curPrev}
                  setCurPrev={setCurPrev}
              />


              <FormGroup
                // indentation="md"
                // border="lg"
                // label="Policy highlights"
                >



                {gcRefunds.map((oneRef, ind) => {
                  return (
                    <FormGroup key={`onereason_${ind}`} indentation="xs">
                      {/* <PAh2 title={oneRef['title']} tag="h4" /> */}
                      <div indentation="xs">
                        <div className="l_flex">
                          <Icon
                            name={
                              policies[curPrev]['presets'][level]["reasons"].indexOf(oneRef["id"]) >
                              -1
                                ? "checkmark"
                                : "block"
                            }
                          />
                          &nbsp;
                          <b
                            style={
                              {
                                // opacity: policies[level]['reasons'].indexOf(oneRef['id']) > -1 ? 1 : 0.3
                              }
                            }
                          >
                            {oneRef["title"]}
                          </b>
                        </div>
                      </div>
                    </FormGroup>
                  );
                })}



              </FormGroup>





              <FormGroup indentation="lg" label="A refund policy badge">
                <PArefundsBadge level={level} product={curPrev} />
              </FormGroup>



            </PAContentBlock>

            {/* <br/> */}

            {/* <PAContentBlock
              nopadding={true}
              title="Policy Preview"
              border={false}
              // sticky="Strict policy"
            >
              <FormGroup indentation="lg">
                <PArefundPreview/>
              </FormGroup>
            </PAContentBlock> */}


          </FormGroup>


          <FormFooter sticky={true}>
            <Button appearance="outline" onClick={()=>{history.history.push('/accounting/refunds')}}>Discard</Button>
            <Button appearance="secondary" onClick={
              ()=>{history.history.push('/accounting/refunds')
              handleSave(level)
            }}>Save new policy</Button>
          </FormFooter>

        </ContentBlock>

    </div>
  );
}


export const policies1 = {
  loyal: {
    reasons: [
      "notReceived",
      "duplicate",
      "notCompatible",
      "notFunctioning",
      "general"
    ]
  },
  moderate: {
    reasons: ["notReceived", "duplicate", "notCompatible", "notFunctioning"]
  },
  strict: {
    reasons: ["notReceived"]
  }
};



const CssPreset = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CssEmoji = styled.div`
  /* background: #efefef; */
  background: #ffffff;
  border-radius: 100px;
  text-align: center;
  /* margin-right: 0.4em; */
  padding: 2px 0 0 4px;
  font-size: 13px;
  min-height: 22px;
  min-width: 22px;
`;



export const getCountries = () => {
  return gcCountries.map((oneCountry, ind) => ({
    label: (
      <CssTableCountry>
        <CssTableFlag>{oneCountry["icon"]}</CssTableFlag>
        {oneCountry["name"]}
      </CssTableCountry>
    ),
    value: ind
  }));
};


